export default __webpack_public_path__ + "img/test02.03563cc6.svg";